







































































# import settings from '@/settings'
import n from '@/utils/notifications'
import m from '@/graphql/mutation'
import q from '@/graphql/query'
import activities from '@/components/jobs_tab/activities'
import skills from '@/components/jobs_tab/skills'
import qualities from '@/components/jobs_tab/qualities'
import knowledges from '@/components/jobs_tab/knowledges'
import capacitations from '@/components/jobs_tab/capacitations'

export default {
    name: 'company_jobs_edition'
    props:
        uid: {
            type: String
            required: false
            default: ''
        }

    components: {
        activities, skills, capacitations, knowledges, qualities
    }

    data: ()->
        true: true
        false: false
        graduate_level_choice_set: @$store.state.graduate_level_choice_set
        errors: {}
        clearable: true
        job: {
            uid: ''
            company_uid: ''
            name: ''
            definition: ''
            graduate_level: {uid: ''}
            graduate_mandatory: false
        }
        activities: []
        knowledges: []
        qualities: []
        skills: []
        capacitations: []
        deletions: []
        selected_tab: 'activities'

    methods:
        graduate_change: ()->
            # console.log "GRADUATE CHANGE ", @job.graduate_level
            return

        active: (tab)->
            tab_cls = ''
            if @selected_tab == tab
                tab_cls = 'active'
            return tab_cls

        change_tab: (tab)->
            @selected_tab = tab

        get_job: (job_uid)->
            self = @
            q.run('get_job', [job_uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_jobs_edition: get_job: then", e.message)
                else
                    # console.log "GET ONE JOB : ", resp.body.data.job
                    self.job = resp.body.data.job
                    if self.job.graduate_level == null
                        self.job.graduate_level = {uid:''}
                    self.get_job_skills()
            .catch (resp)->
                n.catch_error(resp, "company_jobs_edition: get_job()")

        get_job_skills: ()->
            self = @
            q.run('get_job_skill_set', [@job.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_jobs_edition: get_job_skills: then", e.message)
                else
                    # console.log "RUN QUERY JOB SKILLS : ", resp.body.data.job_skill_set
                    self.activities = resp.body.data.job_skill_set.filter (x)-> x.skill_type == 'activity'
                    self.knowledges = resp.body.data.job_skill_set.filter (x)-> x.skill_type == 'knowledge'
                    self.qualities = resp.body.data.job_skill_set.filter (x)-> x.skill_type == 'quality'
                    self.skills = resp.body.data.job_skill_set.filter (x)-> x.skill_type == 'skill'
                    self.capacitations = resp.body.data.job_skill_set.filter (x)-> x.skill_type == 'capacitation'
                    # console.log "RUN QUERY ACTIVITIES : ", self.activities
            .catch (resp)->
                n.catch_error(resp, "company_jobs_edition: get_job_skills()")

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        save: ()->
            # console.log "JOB EDITION SAVE", @job
            # console.log "JOB EDITION SAVE", @activities
            @job.company_uid = @$store.getters.current_company.uid
            self = @
            m.run('save_job', [@job])
            .then (resp)->
                if resp.body.data.job_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.job_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.job_form_mutation.errors
                    self.errors = resp.body.data.job_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    self.save_skills(resp.body.data.job_form_mutation.form_ret)
            .catch (resp)->
                n.catch_error(resp, "company_jobs_edition: save()")

        save_skills: (job_uid)->
            self = @
            all_skills = []
            # console.log "SAVE SKILLS ", @activities
            # console.log "SAVE SKILLS ", @deletions
            if @activities.length >= 1
                for a in @activities
                    all_skills.push(a)
            if @knowledges.length >= 1
                for k in @knowledges
                    all_skills.push(k)
            if @qualities.length >= 1
                for qu in @qualities
                    all_skills.push(qu)
            if @skills.length >= 1
                for s in @skills
                    all_skills.push(s)
            if @capacitations.length >= 1
                for c in @capacitations
                    all_skills.push(c)
            m.run('save_skills', [all_skills, job_uid, @deletions])
            .then (resp)->
                # console.log "SKILL MUTATION RESPONSE", resp.body.data.skills_mutation
                if self.job.uid == ''
                    self.$router.push({ name: 'company_jobs_edition', params: { uid: job_uid } })
                    self.job.uid = job_uid
                self.get_job(job_uid)
                self.deletions = []
                n.success()
            .catch (resp)->
                n.catch_error(resp, "company_jobs_edition: save_skills()")

    beforeMount: ()->
        if @uid != '0'
            @get_job(@uid)
        # console.log "JOBS EDITION", @uid, @job
}
